import React from 'react';
import { connect } from 'react-redux';
import favorite from '../../assets/images/orders-icon.svg';
import favoriteTagged from '../../assets/images/orders-icon-tagged.svg';
import { toggleOrderTagged, receiptLoading } from '../../actions/receipt';


class HistoryReorderItem extends React.Component {

    printOrderDetails() {
        let counter = 0;
        let overflowCounter = 0;
        let details = [];

        this.props.item.order_information.specials.forEach((theItem) => {
            if (counter < 3) {
                details.push((
                    <p key={"item-"+counter}>({theItem.quantity}x) {theItem.name}</p>
                ));
                counter++;
            }
            else {
                overflowCounter++;
            }
        });
        
        let numberOfFoodItems = this.props.item.order_information.foodItems.length
        let foodItemCounter = 0
        this.props.item.order_information.foodItems.forEach((theItem) => {
         
           
            if (counter < 3) {
                // the last of food items doesn't have a comma at the end..
                
              if ( foodItemCounter < (numberOfFoodItems - 1) ){

             
                details.push((
                    <p key={"item-"+counter}>({theItem.quantity}x) {(theItem.size != '<default>') && theItem.size+" "}{theItem.name}, </p>
                ));
                counter++;
                foodItemCounter++;
            } else {
                details.push((
                    <p key={"item-"+counter}>({theItem.quantity}x) {(theItem.size != '<default>') && theItem.size+" "}{theItem.name} </p>
                ));
                counter++;
                foodItemCounter = 0;
            }

            }

            

            else {
                overflowCounter++;
            }
        });

        let numberOfPizzaItems = this.props.item.order_information.pizzas.length
        let pizzaItemCounter = 0;
        
        this.props.item.order_information.pizzas.forEach((theItem) => {
            if (counter < 3) {

                if ( pizzaItemCounter < (numberOfPizzaItems - 1) ) {
                    
                details.push((
                    <p key={"item-"+counter}>({theItem.quantity}x) {theItem.size} {theItem.name}, </p>
                ));
                counter++;
                pizzaItemCounter++
            } else{
                details.push((
                    <p key={"item-"+counter}>({theItem.quantity}x) {theItem.size} {theItem.name} </p>
                ));
                counter++;
                pizzaItemCounter = 0
            }
        }
            else {
                overflowCounter++;
            }
        });


        let numberOfBeverageItems = this.props.item.order_information.beverages.length
        let beverageItemCounter = 0

        this.props.item.order_information.beverages.forEach((theItem) => {
            if (counter < 3) {

                if ( beverageItemCounter < (numberOfBeverageItems - 1)) {

               

                details.push((
                    <p key={"item-"+counter}> ({theItem.quantity}x) {(theItem.size != '<default>') && theItem.size+" "}{theItem.name},</p>
                ));
                counter++;
                beverageItemCounter++
            } else {
                details.push((
                    <p key={"item-"+counter}> ({theItem.quantity}x) {(theItem.size != '<default>') && theItem.size+" "}{theItem.name}</p>
                ));
                counter++;
                beverageItemCounter = 0
            }
            }
            else {
                overflowCounter++;
            }
        });


        let numberOfAddons = this.props.item.order_information.addons.length
        let addOnCounter = 0
        this.props.item.order_information.addons.forEach((theItem) => {
            if (counter < 3) {
                if ( addOnCounter < (numberOfAddons - 1) ) {

                
                details.push((
                    <p key={theItem.id}>  ({theItem.quantity}x) {theItem.name},</p>
                ));
                counter++;
                addOnCounter++
                } else {
                    details.push((
                        <p key={theItem.id}>  ({theItem.quantity}x) {theItem.name}</p>
                    ));
                    counter++;
                    addOnCounter = 0
                }
            }
            else {
                overflowCounter++;
            }
        });

        if (overflowCounter > 0) {
            details.push((
                <p key={"overflow"+this.props.item.id}>- And {overflowCounter} more!</p>
            ));
        }

        return details;
    }

    deleteOrderConfirm(){

        var retVal = confirm("Are you sure you want to untag this order?");

        if(retVal){
            this.tagOrderToggle();
        }

    }

    handleTagClick(){
        if(this.props.item.tagged == 1){
            this.deleteOrderConfirm();
        }else{
            this.tagOrderToggle();
        }
    }

    tagOrderToggle(){
        let item = this.props.item;

        const { token } = this.props;

        const params = {
            item: item,
        };

        this.props.dispatch(receiptLoading());
        this.props.dispatch(toggleOrderTagged(item.id, item.tagged, token, this.props.orderHistory));
    }

    getOrderColor(){
        return (this.props.item.tagged == 1) ? favoriteTagged: favorite;
    }

    render() {
        return (
            <div className="order-item-wrapper-outer" >
                <div className="order-item-wrapper-inner" >
                    <div className="history-orderBody">
                        <div className="order-title display-block">{this.props.item.order_date} - {this.props.item.pickup_time_formatted}</div>
                        <div className="order-title price-div">${this.props.item.total}</div>
                        <div className="order-details-div">
                            <p className="order-description place">{this.props.item.restaurant_name}</p>
                            <p className="order-description order">{this.printOrderDetails()}</p>
                        </div>
                        <div>{this.props.loading && false}</div>
                    </div>
                    {!this.props.recentOrder && (
                        <div className="history-orderTag" onClick={() => { this.handleTagClick() }} >
                            <img src={this.getOrderColor()}  className="most-small-icons" />
                        </div>
                    )}
                </div>
                {(!this.props.recentOrder) && (
                    <a className="receiptButton" onClick={() => { this.props.handleSelectOrder(this.props.item) }} >
                        View Receipt
                    </a>
                )}
                {(this.props.recentOrder) && (
                    <div className="buttonContainer">
                        <a className="receiptButton" onClick={() => { this.props.handleSelectOrder(this.props.item) }} >
                            View Receipt
                        </a>
                        <a className="statusButton" onClick={() => { this.props.viewCurrentStatus(this.props.item) }} >
                            View Status
                        </a>
                    </div>
                )}

            </div>

        );
    }
}

const mapStateToProps = (state) => {

    return {
        orderHistory: state.auth.user.orderHistory,
        token: state.auth.token,
        loading: state.receipt.loading,
        logged_in: state.auth.logged_in
    };
};

export default connect(mapStateToProps)(HistoryReorderItem);
